module.exports = __webpack_public_path__ + "img/1-md.9ead155e.jpg";